import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6b6f930"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ellipsis width" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "text-red"
}

import {ref, computed, watch, onMounted} from 'vue';
  import {useGetListUserOptions} from 'src/services/domains/employees/useGetListUserOptions';

  
export default /*#__PURE__*/_defineComponent({
  name: 'UserSelect',
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: ''
    },
    label: {
      type: String,
    },
    errors: {
      type: Array,
      default: () => []
    },
    class: {
      type: String,
      default: ''
    },
    disabledUsers: {
      type: Array,
      default: () => []
    },
    showDepartment: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    nonExistentLabel: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props

  
  
  const model = computed({
    get: () => {
      if (props.multiple) {
        return props.modelValue ? Object.values(props.modelValue).map((item: string) => parseInt(item)) : [];
      }
      return parseInt(props.modelValue);
    },
    set: (value) => {return emit('update:modelValue', value)}
  });
  const {userOptions} = useGetListUserOptions(props.showDepartment);
  const mapUserOptions = computed(() => {
    return userOptions.value.map(user => {
      return {
        ...user,
        disable: !!props.disabledUsers.length && props.disabledUsers.includes(user.value)
      }
    })
  });
  const filteredOptions = ref([]);
  const filter = (val: string, update) => {
    update(() => {
      filteredOptions.value = mapUserOptions.value.filter(option => {
        return !val || option.label.toLowerCase().includes(val.toLocaleLowerCase())
      });
    })
  };
  const extraClass = ref(props.class);

  onMounted(() => {
    filteredOptions.value = mapUserOptions.value;
  });

  watch(() => mapUserOptions.value,
    (val) => {
        filteredOptions.value = val;
    });

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    label: __props.label,
    modelValue: _unref(model),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    options: filteredOptions.value,
    error: !!__props.errors.length,
    class: _normalizeClass(["user-input", extraClass.value]),
    onFilter: filter,
    "use-input": "",
    "emit-value": "",
    "map-options": "",
    dense: "",
    multiple: __props.multiple
  }, _createSlots({
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _mergeProps(scope.itemProps, _toHandlers(scope.itemEvents)), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "option" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, { class: "ellipsis q-chip-select" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt.label), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.errors[0]), 1)
    ]),
    append: _withCtx(() => [
      ((__props.multiple && _unref(model).length) || (!__props.multiple && !!_unref(model)))
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            class: "cursor-pointer",
            name: "clear",
            size: "14px",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (model.value = ''), ["stop","prevent"]))
          }))
        : _createCommentVNode("", true)
    ]),
    label: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(__props.label) + " ", 1),
        (__props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (!__props.multiple)
      ? {
          name: "selected-item",
          fn: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(scope.opt.label || (!!_unref(model) ? __props.nonExistentLabel : '')), 1)
          ])
        }
      : undefined
  ]), 1032, ["label", "modelValue", "options", "error", "class", "multiple"]))
}
}

})